import React from 'react';
import { useRef, useState } from 'react';
function Icon({ name, size = 20 }) {
  const paths = {
    arrow: (
      <>
        <path d="M19 12H5" />
        <path d="m12 19-7-7 7-7" />
      </>
    ),
    camera: (
      <>
        <path d="M14.5 4 16 7h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h3l1.5-3h5Z" />
        <circle cx="12" cy="13" r="3.5" />
      </>
    ),
    check: <path d="m5 12 4 4L19 6" />,
    chevron: <path d="m9 18 6-6-6-6" />,
    close: (
      <>
        <path d="m6 6 12 12" />
        <path d="m18 6-12 12" />
      </>
    ),
    drag: (
      <>
        <circle cx="9" cy="7" r="1" fill="currentColor" stroke="none" />
        <circle cx="15" cy="7" r="1" fill="currentColor" stroke="none" />
        <circle cx="9" cy="12" r="1" fill="currentColor" stroke="none" />
        <circle cx="15" cy="12" r="1" fill="currentColor" stroke="none" />
        <circle cx="9" cy="17" r="1" fill="currentColor" stroke="none" />
        <circle cx="15" cy="17" r="1" fill="currentColor" stroke="none" />
      </>
    ),
    edit: (
      <>
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z" />
      </>
    ),
    eye: (
      <>
        <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z" />
        <circle cx="12" cy="12" r="2.5" />
      </>
    ),
    image: (
      <>
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <circle cx="9" cy="10" r="2" />
        <path d="m21 15-4-4L5 20" />
      </>
    ),
    info: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5" />
        <path d="M12 8h.01" />
      </>
    ),
    lock: (
      <>
        <rect x="5" y="10" width="14" height="11" rx="2" />
        <path d="M8 10V7a4 4 0 0 1 8 0v3" />
      </>
    ),
    mail: (
      <>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="m3 7 9 6 9-6" />
      </>
    ),
    plus: (
      <>
        <path d="M12 5v14" />
        <path d="M5 12h14" />
      </>
    ),
    refresh: (
      <>
        <path d="M20 7v5h-5" />
        <path d="M4 17a8 8 0 0 0 14-5 8 8 0 0 0-14-5" />
      </>
    ),
    shield: (
      <>
        <path d="M12 3 5 6v5c0 4.5 2.8 8.2 7 10 4.2-1.8 7-5.5 7-10V6Z" />
        <path d="m9 12 2 2 4-4" />
      </>
    ),
    spark: (
      <path d="m12 3 1.7 5.3L19 10l-5.3 1.7L12 17l-1.7-5.3L5 10l5.3-1.7Z" />
    ),
    trash: (
      <>
        <path d="M4 7h16" />
        <path d="M9 7V4h6v3" />
        <path d="m7 7 1 14h8l1-14" />
      </>
    ),
  };
  return (
    <svg
      aria-hidden="true"
      className="icon"
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
    >
      {paths[name]}
    </svg>
  );
}
function Brand() {
  return (
    <div className="brand" aria-label="LifeTagger">
      <img
        alt=""
        className="brand-logo"
        height="32"
        src="/images/lifeTagger_logo.png"
        width="32"
      />
      <span>LifeTagger</span>
    </div>
  );
}
function Button({
  children,
  onClick,
  variant = 'primary',
  icon,
  disabled,
  type = 'button',
}) {
  return (
    <button
      className={`button ${variant}`}
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {icon && <Icon name={icon} />}
      <span>{children}</span>
    </button>
  );
}
function Header({ action, back }) {
  return (
    <header className="header">
      <div className="header-inner">
        {back ? (
          <button aria-label="Go back" className="icon-button" onClick={back}>
            <Icon name="arrow" />
          </button>
        ) : (
          <Brand />
        )}
        <div className="header-action">{action}</div>
      </div>
    </header>
  );
}
function PublicNote() {
  return (
    <div className="public-note">
      <Icon name="eye" />
      <p>
        <strong>Anyone with this LifeTap link can view this.</strong> Only you
        can make changes from this browser.
      </p>
    </div>
  );
}
function Unlock({ onSuccess, onRecovery }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  async function submit(event) {
    event.preventDefault();
    if (!code.trim()) {
      setError('Enter the code inside your pack.');
      return;
    }
    setLoading(true);
    try {
      await onSuccess(code);
    } catch (failure) {
      setError(failure.message || 'Please try again.');
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      <Header />
      <main className="narrow unlock-page">
        <div className="tag-hero" aria-hidden="true">
          <div className="tag-rings">
            <span />
            <span />
            <span />
          </div>
          <div className="tap-symbol">
            <img
              alt=""
              height="32"
              src="/images/lifeTagger_logo.png"
              width="32"
            />
          </div>
        </div>
        <div className="eyebrow">
          <Icon name="spark" size={16} /> One quick step
        </div>
        <h1>Make this LifeTap yours</h1>
        <p className="lead">
          Add photos, notes, or a list to share useful details about anything
          you tag.
        </p>
        <form className="unlock-form" onSubmit={submit}>
          <label htmlFor="pack-code">Pack unlock code</label>
          <p className="field-help">
            Find it inside the packaging or under the peel-away panel.
          </p>
          <input
            aria-describedby={error ? 'code-error' : undefined}
            autoCapitalize="characters"
            className={error ? 'input error-input' : 'input'}
            id="pack-code"
            maxLength={64}
            onChange={(e) => {
              setCode(e.target.value.toUpperCase());
              setError(false);
            }}
            placeholder="e.g. LT8–K4P"
            value={code}
          />
          {error && (
            <div className="error-message" id="code-error">
              <Icon name="info" size={18} />
              <span role="alert">{error}</span>
            </div>
          )}
          <Button disabled={loading} type="submit">
            {loading ? (
              <>
                <span className="spinner" /> Checking code…
              </>
            ) : (
              'Unlock this pack'
            )}
          </Button>
        </form>
        <div className="soft-card">
          <Icon name="shield" />
          <p>
            <strong>One code unlocks your whole pack.</strong> This browser can
            then edit every LifeTap in it. The public LifeTap link alone never
            allows editing.
          </p>
        </div>
        <button className="text-button" onClick={onRecovery}>
          Already claimed or can’t use your code?
        </button>
      </main>
    </>
  );
}
function Editor({
  mode,
  initialPhotos,
  initialTitle,
  initialNote,
  initialItems,
  onCancel,
  onSave,
  onUpload,
  tapName = 'LifeTap',
}) {
  const [photos, setPhotos] = useState(initialPhotos);
  const [title, setTitle] = useState(initialTitle);
  const [note, setNote] = useState(initialNote);
  const [items, setItems] = useState(initialItems);
  const [item, setItem] = useState('');
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState(false);
  const [preview, setPreview] = useState(null);
  const camera = useRef(null);
  const chooser = useRef(null);
  const [uploading, setUploading] = useState(false);
  async function addPhotos(event) {
    const files = Array.from(event.target.files || []).slice(
      0,
      6 - photos.length
    );
    event.target.value = '';
    setUploading(true);
    setSaveError(false);
    try {
      for (const file of files) {
        const photo = await onUpload(file);
        setPhotos((current) => [...current, photo]);
      }
    } catch (error) {
      setSaveError(
        error.message || 'Upload failed. Choose the photo again to retry.'
      );
    } finally {
      setUploading(false);
    }
  }
  function addItem() {
    if (!item.trim()) return;
    setItems((current) => [...current, item.trim()]);
    setItem('');
  }
  function movePhoto(index, direction) {
    const next = [...photos];
    const target = index + direction;
    if (target < 0 || target >= next.length) return;
    [next[index], next[target]] = [next[target], next[index]];
    setPhotos(next);
  }
  async function save() {
    setSaving(true);
    setSaveError(false);
    try {
      await onSave({
        photos: photos.filter((photo) => !photo.failed),
        title,
        note,
        items,
      });
    } catch (error) {
      setSaveError(error.message || 'Check your connection and try again.');
    } finally {
      setSaving(false);
    }
  }
  return (
    <>
      <Header
        back={onCancel}
        action={
          <button className="header-cancel" onClick={onCancel}>
            Cancel
          </button>
        }
      />
      <main className="content lifetap-editor">
        <div className="editor-heading">
          <div>
            <div className="eyebrow">
              {mode === 'create' ? 'LifeTap ready' : 'Editing'}
            </div>
            <h1>
              {mode === 'create'
                ? 'What would you like to add?'
                : 'Update this LifeTap'}
            </h1>
          </div>
          <span className="lifetap-pill">{tapName}</span>
        </div>
        <p className="lead compact">
          Use any combination of photos, notes, or a list. You can change this
          anytime.
        </p>

        <section className="section">
          <div className="section-title">
            <div>
              <span className="step">1</span>
              <h2>Photos</h2>
            </div>
            <span>{photos.length} of 6</span>
          </div>
          <div className="photo-actions">
            <input
              hidden
              ref={camera}
              type="file"
              accept="image/*"
              capture="environment"
              onChange={addPhotos}
            />
            <input
              hidden
              ref={chooser}
              type="file"
              accept="image/*"
              multiple
              onChange={addPhotos}
            />
            <Button
              disabled={uploading || photos.length >= 6}
              icon="camera"
              onClick={() => camera.current.click()}
              variant="secondary"
            >
              Take photo
            </Button>
            <Button
              disabled={uploading || photos.length >= 6}
              icon="image"
              onClick={() => chooser.current.click()}
              variant="secondary"
            >
              Choose photo
            </Button>
          </div>
          {photos.length > 0 && (
            <div className="photo-grid">
              {photos.map((photo, index) => (
                <div
                  className={`photo-tile ${photo.failed ? 'photo-failed' : ''}`}
                  key={photo.id}
                >
                  {photo.failed ? (
                    <div className="failed-inner">
                      <Icon name="info" />
                      <span>Upload paused</span>
                      <button
                        onClick={() =>
                          setPhotos((current) =>
                            current.map((p) =>
                              p.id === photo.id
                                ? {
                                    ...p,
                                    failed: false,
                                  }
                                : p
                            )
                          )
                        }
                      >
                        <Icon name="refresh" size={16} /> Retry
                      </button>
                    </div>
                  ) : (
                    <button
                      className="photo-preview"
                      onClick={() => setPreview(photo)}
                    >
                      <img alt={photo.alt} src={photo.url} />
                    </button>
                  )}
                  <button
                    aria-label="Remove photo"
                    className="remove-photo"
                    onClick={() =>
                      setPhotos((current) =>
                        current.filter((p) => p.id !== photo.id)
                      )
                    }
                  >
                    <Icon name="close" size={16} />
                  </button>
                  <div className="photo-order">
                    <button
                      aria-label="Move photo earlier"
                      disabled={index === 0}
                      onClick={() => movePhoto(index, -1)}
                    >
                      ‹
                    </button>
                    <Icon name="drag" size={18} />
                    <button
                      aria-label="Move photo later"
                      disabled={index === photos.length - 1}
                      onClick={() => movePhoto(index, 1)}
                    >
                      ›
                    </button>
                  </div>
                </div>
              ))}
              {photos.length < 6 && (
                <button
                  disabled={uploading}
                  className="add-photo-tile"
                  onClick={() => chooser.current.click()}
                >
                  <Icon name="plus" />
                  <span>Add another</span>
                </button>
              )}
            </div>
          )}
          {uploading && <p role="status">Uploading photo…</p>}
        </section>

        <section className="section">
          <div className="section-title">
            <div>
              <span className="step">2</span>
              <h2>Details</h2>
            </div>
          </div>
          <label htmlFor="title">
            Title <span>Optional</span>
          </label>
          <input
            className="input"
            id="title"
            onChange={(e) => setTitle(e.target.value)}
            placeholder="e.g. Projector setup"
            value={title}
          />
          <label htmlFor="notes">
            Helpful note <span>Optional</span>
          </label>
          <textarea
            className="input textarea"
            id="notes"
            onChange={(e) => setNote(e.target.value)}
            placeholder="Add instructions, context, or a story…"
            value={note}
          />
        </section>

        <section className="section">
          <div className="section-title">
            <div>
              <span className="step">3</span>
              <h2>
                List <span className="optional-heading">Optional</span>
              </h2>
            </div>
            <span>
              {items.length} {items.length === 1 ? 'entry' : 'entries'}
            </span>
          </div>
          <div className="add-item-row">
            <input
              className="input"
              onChange={(e) => setItem(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  addItem();
                }
              }}
              placeholder="Add a list entry"
              value={item}
            />
            <button
              aria-label="Add list entry"
              className="square-button"
              onClick={addItem}
            >
              <Icon name="plus" />
            </button>
          </div>
          {items.length > 0 && (
            <ul className="edit-list">
              {items.map((entry, index) => (
                <li key={`${entry}-${index}`}>
                  <Icon name="drag" />
                  <span>{entry}</span>
                  <button
                    aria-label={`Remove ${entry}`}
                    onClick={() =>
                      setItems((current) =>
                        current.filter((_, i) => i !== index)
                      )
                    }
                  >
                    <Icon name="trash" size={18} />
                  </button>
                </li>
              ))}
            </ul>
          )}
        </section>
        <PublicNote />
        {saveError && (
          <div className="save-error">
            <Icon name="info" />
            <div role="alert">
              <strong>Couldn’t finish just yet</strong>
              <p>{saveError} Your changes are still on this screen.</p>
            </div>
          </div>
        )}
        <div className="sticky-save">
          <Button
            disabled={
              (!title.trim() &&
                !note.trim() &&
                items.length === 0 &&
                photos.filter((photo) => !photo.failed).length === 0) ||
              saving ||
              uploading
            }
            onClick={save}
          >
            {saving ? (
              <>
                <span className="spinner" /> Saving safely…
              </>
            ) : mode === 'create' ? (
              'Save and view'
            ) : saveError ? (
              'Try saving again'
            ) : (
              'Save changes'
            )}
          </Button>
        </div>
      </main>
      {preview && (
        <div className="lightbox" role="dialog" aria-label="Photo preview">
          <button aria-label="Close preview" onClick={() => setPreview(null)}>
            <Icon name="close" />
          </button>
          <img alt={preview.alt} src={preview.url} />
          <p>{preview.alt}</p>
        </div>
      )}
    </>
  );
}
function View({
  owner,
  photos,
  title,
  note,
  items,
  onEdit,
  onRecovery,
  tapName = 'LifeTap',
  updatedAt,
  children,
}) {
  const [active, setActive] = useState(0);
  return (
    <>
      <Header
        action={
          owner ? (
            <button className="edit-button" onClick={onEdit}>
              <Icon name="edit" size={18} /> Edit
            </button>
          ) : (
            <span className="view-only">
              <Icon name="eye" size={16} /> View only
            </span>
          )
        }
      />
      <main className="view-page">
        {photos.length > 0 && (
          <div className="view-hero">
            <img alt={photos[active].alt} src={photos[active].url} />
            <div className="hero-gradient" />
            <span className="photo-count">
              <Icon name="image" size={15} /> {active + 1} / {photos.length}
            </span>
            {photos.length > 1 && (
              <div className="photo-dots">
                {photos.map((photo, index) => (
                  <button
                    aria-label={`View photo ${index + 1}`}
                    className={index === active ? 'active' : ''}
                    key={photo.id}
                    onClick={() => setActive(index)}
                  />
                ))}
              </div>
            )}
          </div>
        )}
        <div className="view-content">
          <div className="lifetap-meta">
            <span>{tapName}</span>
            <span>
              {updatedAt
                ? `Updated ${new Date(updatedAt).toLocaleDateString()}`
                : ''}
            </span>
          </div>
          {title && <h1>{title}</h1>}
          {note && <p className="view-note">{note}</p>}
          {items.length > 0 && (
            <section className="list-card">
              <div className="list-header">
                <h2>List</h2>
                <span>
                  {items.length} {items.length === 1 ? 'entry' : 'entries'}
                </span>
              </div>
              <ul>
                {items.map((item, index) => (
                  <li key={`${item}-${index}`}>
                    <span className="check-circle">
                      <Icon name="check" size={15} />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </section>
          )}
          {children}
          <div className="link-disclosure">
            <Icon name="eye" />
            <p>Anyone with this LifeTap link can view these details.</p>
          </div>
          {owner && (
            <button className="recovery-nudge" onClick={onRecovery}>
              <span className="nudge-icon">
                <Icon name="shield" />
              </span>
              <span>
                <strong>Keep your editing access</strong>
                <small>Add a recovery option for a new phone</small>
              </span>
              <Icon name="chevron" />
            </button>
          )}
        </div>
      </main>
    </>
  );
}
function VisitorEmpty({ tapName = 'LifeTap', owner = false, onCreate }) {
  return (
    <>
      <Header
        action={
          <span className="view-only">
            <Icon name="eye" size={16} /> {owner ? 'Your LifeTap' : 'View only'}
          </span>
        }
      />
      <main className="state-page">
        <div className="empty-illustration">
          <div className="empty-box">
            <span />
          </div>
        </div>
        <div className="eyebrow">{tapName}</div>
        <h1>Nothing has been added yet</h1>
        <p>
          {owner
            ? 'Add a photo, a note, or a list whenever you’re ready.'
            : 'There’s nothing available to view here right now. Try again later or ask the owner for more information.'}
        </p>
        {owner && <Button onClick={onCreate}>Add content</Button>}
        <div className="soft-card">
          <Icon name="lock" />
          <p>Only the owner’s approved browser can add or change content.</p>
        </div>
      </main>
    </>
  );
}
function Claimed({ onLost }) {
  return (
    <>
      <Header />
      <main className="state-page">
        <div className="state-icon warning">
          <Icon name="lock" size={32} />
        </div>
        <div className="eyebrow">Pack already claimed</div>
        <h1>This pack is already linked</h1>
        <p>
          For safety, the original pack code can’t be used again. If this is
          your pack, restore your editing access instead.
        </p>
        <Button icon="refresh" onClick={onLost}>
          Restore editing access
        </Button>
        <PublicNote />
      </main>
    </>
  );
}
export {
  Icon,
  Brand,
  Button,
  Header,
  PublicNote,
  Unlock,
  Editor,
  View,
  VisitorEmpty,
  Claimed,
};
